import { useTranslation } from 'react-i18next';

import TimerGif from '../../../../../../assets/timer.gif';
import { i18nNS } from '../../../../i18n';
import TileIntroductionForm, { TileIntroductionFormProps } from '../../../shared/TileIntroductionForm';
import TileIntroductionLayout from '../../../shared/TileIntroductionLayout';
import useIntroduction, { UseIntroduction } from './vm';

export interface IntroductionProps
  extends Pick<TileIntroductionFormProps, 'className' | 'onNext'>,
    UseIntroduction {}

const Introduction = ({ className, onNext, ...vmProps }: IntroductionProps) => {
  const { t } = useTranslation([i18nNS.TIMER]);

  useIntroduction(vmProps);

  return (
    <TileIntroductionForm className={className} onNext={onNext}>
      <TileIntroductionLayout
        imageSrc={TimerGif}
        description={t(
          'set_a_time_limit_start_the_timer_and_watch_it_count_down_to_0_to_time_group_activities_discussions_or_simply_take_a_time_out_pause_and_restart_as_per_your_convenience',
          { ns: i18nNS.TIMER }
        )}
        color="warning"
        studentRespondsOn={{
          iOS: false,
          android: false,
          web: false,
        }}
      />
    </TileIntroductionForm>
  );
};

export default Introduction;
